/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { InputText, InputTextProps } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import styled from 'styled-components';
import { Button } from 'primereact/button';

interface ProjectSearchBarProps extends InputTextProps {
  onClear?: () => void;
  isLoading: boolean;
}

const InputWrapper = styled(IconField)`
  margin-left: 0.25rem;
  margin-right: 0.7rem;
  display: flex;
  align-items: center;
  .p-button {
    height: 100%;
    border: none;
    background: transparent;
    padding: 0;
    width: fit-content;
  }
  .p-inputgroup-addon {
    margin-left: -3.25rem;
    background: transparent;
  }
`;

export const ProjectSearchBar: React.FC<ProjectSearchBarProps> = (props: ProjectSearchBarProps) => {
  const isClearable = props.value && props.value.toString().trim().length > 0;
  const { isLoading, onClear, ...rest } = props;
  return (
    <InputWrapper className="w-full" iconPosition="left">
      <InputIcon className="pi pi-search"></InputIcon>
      <InputText {...rest} />
      <span className="p-inputgroup-addon p-0 border-0">
        {isLoading || isClearable ? <Button text loading={isLoading} icon="pi pi-times" onClick={onClear} /> : null}
      </span>
    </InputWrapper>
  );
};
